import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { PointsMngPoolPoint } from 'src/app/interface/overview.interface';
import { ToasterService } from 'src/app/services/toaster.service';

import { VesselsService } from 'src/app/services/vessels.service';
@Component({
  selector: 'app-edit-pool-points',
  templateUrl: './edit-pool-points.component.html',
  styleUrls: ['./edit-pool-points.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EditPoolPointsComponent implements OnInit {
  
  searchText:string = '';
  isOpen: boolean;
  headerName = 'Edit pool points'
  switchLng:boolean = false;
  maxLength:number = 500;
  maxLengths:number = 300;
  isTextError:boolean = false;
  editPoolPointsVal:string = 'editPoolPointsVal_1';
  @Input() poolPointDetails:any;
  @Input() shipDetailsbasicinfo:any;
  @Output() getupdatePoolPoints = new EventEmitter();
  @Output() emitPoolPointsDetails = new EventEmitter();
  @Output() getPoolPointLoaderEvent = new EventEmitter();
  @Output() errorPoolPointLoaderEvent = new EventEmitter();
  

  selectedPoolPointsDateVal: any;
  poolPointsReason: string = '';
  selectedNewPoolPointsDateVal: any = null;
  poolPointsNewReason: string = '';
  openEditPoolPoints:boolean = false;
  poolPointsReasonError: boolean = false;
  newPoolPointForm: UntypedFormGroup;
  // private readonly decimalPattern = /^[1-9]\d*(?:\.\d{1,2})?$/;
  private readonly decimalPattern = /^(?:0|[1-9]\d*)(?:\.\d{1,2})?$/;
  newPoolPointVal: any = null;
  pendingCalcPoolPointVal:any = null;
  poolPointsNewReasonError: boolean = false;
  updatePoolPointsData: any;
  upComingDate: any;
  upComingReason: string = '';
  newUpcomingReason: string = '';
  selectedUpcomingDate: any;
  openDiscardPoolPoint: boolean = false;
  openRestorePoolPoint:boolean = false;
  getFYdate: any;
  disableFYdate: any;
  vesselActivationDate: any;
  discardSuccess: boolean = false;
  updatePayload: { vslNumber: any; poolPoint: number; poolPointEffectiveFrom: string | null; poolPointReason: string; };
  discardPoolPointData: any;
  revertPoolPointData: any;
  pendingCalcDate: any;
  pendingCalcReason: string = '';
  pendingCalcReasonError: boolean = false;
  showDiscardBanner: boolean = false;
  noChangeDate: any;
  noChangeReason: string = '';
  showNewPoolPointsErrorMsg: boolean = false;
  showPoolPointsPendingErrorMsg: boolean = false;

  private readonly poolPointsRequiredMessages: Record<string, string> = {
    newPoolPoints: 'New pool points are required.',
    pendingCalcPoolPoints: 'Current pool points are required.',
  };
  private readonly poolPointsPatternMessage = 'Please enter a valid decimal input.';

  constructor(private vesselService:VesselsService, 
    private toasterService: ToasterService,
    private fb: UntypedFormBuilder,
    private datePipe: DatePipe) {
  }

  ngOnInit() {
   console.log(this.shipDetailsbasicinfo)
   this.newPoolPointForm = this.fb.group({
    newPoolPoints: ['' , [Validators.required,Validators.pattern(this.decimalPattern)]],
    pendingCalcPoolPoints :['', [Validators.required,Validators.pattern(this.decimalPattern)]],
      
    });
    console.log(this.newPoolPointForm)
    this.newPoolPointForm.valueChanges.pipe(debounceTime(1000),distinctUntilChanged()).subscribe((value:any) => {
    console.log(value)
      this.newPoolPointVal = value;
      this.pendingCalcPoolPointVal = value;
    })
  }   
  editPoolPoints(){
  //  this.callGetPoolPointDetails();
    this.callPoolPointsData();
  }

  checkPoolPointsValidation(){
    this.editPoolPointsVal = '';
    this.pendingCalcReason = '';
    this.pendingCalcDate = null;
    this.poolPointsNewReason = '';
    this.newUpcomingReason = '';
    this.selectedUpcomingDate = null;
    this.upComingDate = null;
    this.upComingReason = '';
    this.newPoolPointForm.patchValue({
      newPoolPoints: '',
      pendingCalcPoolPoints:''
    });
    this.newPoolPointForm.markAsUntouched(); 
    this.newPoolPointForm.markAsPristine()
    this.showNewPoolPointsErrorMsg = false;
    this.showPoolPointsPendingErrorMsg = false;
  }
  poolPointsDeatilsSidePanelData(){
    this.openEditPoolPoints = true;
    this.vesselActivationDate = this.poolPointDetails?.vesselActivationDate;
    this.getFYdate = sessionStorage.getItem('fiscalYearStartDate');
    const date  = new Date(this.getFYdate);
    let newDate = new Date(date.setDate(date.getDate() - 1));
    this.disableFYdate = new Date(newDate.toISOString().slice(0, 10));
    console.log(this.disableFYdate)
    console.log(this.vesselActivationDate)
    this.vesselActivationDate = new Date(this.vesselActivationDate)
    if(this.poolPointDetails?.hasPreviousChange){
      if(this.poolPointDetails?.status === 'upcomingChange'){
        this.editPoolPointsVal = 'editPoolPointsVal_3'
        this.newPoolPointForm.patchValue({
          newPoolPoints: this.formatPoolPointsForInput(this.poolPointDetails?.upComingPoolPoint)
        });
        this.upComingDate = this.poolPointDetails?.upcomingEffectiveDate;
        this.upComingReason = this.poolPointDetails?.upcomingReason ?? '';
        this.newUpcomingReason = this.upComingReason;
        this.selectedUpcomingDate = null;
        this.showDiscardBanner = true;
      }
      if(this.poolPointDetails?.status === 'pendingCalculation'){
        this.editPoolPointsVal = 'editPoolPointsVal_4';
        this.newPoolPointForm.patchValue({
          newPoolPoints: '',
          pendingCalcPoolPoints: this.formatPoolPointsForInput(this.poolPointDetails?.currentPoolPoint)
        });
        this.pendingCalcDate = this.poolPointDetails?.currentEffectiveDate;
        this.pendingCalcReason = this.poolPointDetails?.currentReason ?? '';
      }
      if(this.poolPointDetails?.status === 'noChange'){
        this.editPoolPointsVal = 'editPoolPointsVal_1';
        this.noChangeDate = this.poolPointDetails?.currentEffectiveDate;
        this.noChangeReason = this.poolPointDetails?.currentReason;
        this.selectedPoolPointsDateVal = this.poolPointDetails?.currentEffectiveDate;
        this.poolPointsReason = this.poolPointDetails?.currentReason;
      }
    }else{
      this.editPoolPointsVal = 'editPoolPointsVal_1';
      this.noChangeDate = this.poolPointDetails?.currentEffectiveDate;
      this.noChangeReason = this.poolPointDetails?.currentReason;
      this.selectedPoolPointsDateVal = this.poolPointDetails?.currentEffectiveDate;
      this.poolPointsReason = this.poolPointDetails?.currentReason;
    } 
  }
  callPoolPointsData(){
    this.checkPoolPointsValidation();
    this.poolPointsDeatilsSidePanelData();
  }

  callGetPoolPointDetails(){
    // this.editPoolPointsVal = '';
    // this.showNewPoolPointsErrorMsg = false;
    // this.showPoolPointsPendingErrorMsg = false;
    this.checkPoolPointsValidation();
    let input = {"vslNumber": this.shipDetailsbasicinfo?.vslNumber};
    this.vesselService.getPoolPointDetails(input).subscribe({
      next:(res:any)=>{
        console.log(res)
        if(res.data.getPoolPointDetails.success){
          this.poolPointDetails = res.data.getPoolPointDetails.data;
          this.poolPointsDeatilsSidePanelData();
        }
        else{
          this.toasterService.openToast('Error', res.data.getPoolPointDetails.message);
        }
      },
      error:(error:any)=>{
        this.toasterService.openToast('Error', error);
      }
    })
  }
  changePoolPoints(){
    this.editPoolPointsVal = 'editPoolPointsVal_2'
  }
  get minSelectableDate(): Date {
   
    return this.vesselActivationDate > this.disableFYdate
      ? this.vesselActivationDate
      : this.disableFYdate;
  }

  get poolPointsEffectiveDate(): Date | null {
    return this.toPickerDate(this.selectedPoolPointsDateVal ?? this.noChangeDate);
  }

  get upcomingPoolEffectiveDate(): Date | null {
    return this.toPickerDate(this.selectedUpcomingDate ?? this.upComingDate);
  }

  get pendingPoolEffectiveDate(): Date | null {
    return this.toPickerDate(this.pendingCalcDate);
  }

  get upcomingPoolReasonValue(): string {
    return this.newUpcomingReason || this.upComingReason || '';
  }

  private formatPoolPointsForInput(value: unknown): string {
    return value === null || value === undefined || value === '' ? '' : String(value);
  }

  private toPickerDate(value: unknown): Date | null {
    if (!value) {
      return null;
    }
    if (value instanceof Date) {
      return isNaN(value.getTime()) ? null : value;
    }
    const parsed = new Date(value as string);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  selectedPoolPointsDate(e:any){
    this.selectedPoolPointsDateVal = e;
    this.noChangeDate = null;
  }
  poolPointsfieldValue(event:any){
    this.poolPointsReason = event;
    this.noChangeReason = ''
    if(this.poolPointsReason.length >= 500){
      this.poolPointsReasonError = true;
    }else{
      this.poolPointsReasonError = false;
    }
  }
  selectedNewPoolPointsDate(e:any){
    this.selectedNewPoolPointsDateVal = e;
    console.log(e)
  }
  upComingPoolPointsDate(e:any){
    this.selectedUpcomingDate = e;
    this.upComingDate = null;
  }
  newPoolPointsfieldValue(e:any){
    this.poolPointsNewReason = e;
    if(this.poolPointsNewReason.length > 300){
      this.poolPointsNewReasonError = true;
    }else{
      this.poolPointsNewReasonError = false;
    }
    
  }
  updatePoolPoints(){
    this.getPoolPointLoaderEvent.emit();
    let upComingDate = this.datePipe.transform(this.upComingDate,"yyyy-MM-dd");
    let selectedUpcomingDate = this.datePipe.transform(this.selectedUpcomingDate,"yyyy-MM-dd")
    let selectedNewPoolPointsDateVal = this.datePipe.transform(this.selectedNewPoolPointsDateVal,"yyyy-MM-dd")
    console.log(selectedNewPoolPointsDateVal);
    console.log(selectedUpcomingDate);
    console.log(upComingDate);
   
    if(this.poolPointDetails?.hasPreviousChange){
      if(this.poolPointDetails?.status === 'noChange'){
        this.updatePayload = {
        "vslNumber":  this.shipDetailsbasicinfo?.vslNumber,
        "poolPoint": Number(this.newPoolPointVal?.newPoolPoints),
        "poolPointEffectiveFrom":selectedNewPoolPointsDateVal ? selectedNewPoolPointsDateVal : upComingDate,
        "poolPointReason": this.poolPointsNewReason ? this.poolPointsNewReason : this.upComingReason
        }
        console.log("1")
      }
      if(this.poolPointDetails?.status === 'upcomingChange'){
        this.updatePayload = {
        "vslNumber":  this.shipDetailsbasicinfo?.vslNumber,
        "poolPoint": Number(this.newPoolPointVal?.newPoolPoints),
        "poolPointEffectiveFrom": selectedUpcomingDate ? selectedUpcomingDate : upComingDate ,
        "poolPointReason": this.newUpcomingReason  ? this.newUpcomingReason  : this.upComingReason ,
        }
        console.log("2")
      }
      if(this.poolPointDetails?.status === 'pendingCalculation'){
        this.updatePayload = {
        "vslNumber":  this.shipDetailsbasicinfo?.vslNumber,
        "poolPoint": Number(this.pendingCalcPoolPointVal?.pendingCalcPoolPoints),
        "poolPointEffectiveFrom":this.datePipe.transform(this.pendingCalcDate ,"yyyy-MM-dd") ,
        "poolPointReason": this.pendingCalcReason ,
        }
        console.log("3")
      }
    }else{
      this.updatePayload = {
      "vslNumber":  this.shipDetailsbasicinfo?.vslNumber,
      "poolPoint": Number(this.newPoolPointVal?.newPoolPoints),
      "poolPointEffectiveFrom":selectedNewPoolPointsDateVal ? selectedNewPoolPointsDateVal : upComingDate,
      "poolPointReason": this.poolPointsNewReason ? this.poolPointsNewReason : this.upComingReason
      }
      console.log("1")
    }
    console.log(this.updatePayload)
    this.vesselService.updatePoolPointDetails(this.updatePayload).subscribe({
      next:(res:any)=>{
        console.log(res)
        this.updatePoolPointsData = res?.data?.updatePoolPointDetails?.data;
        console.log(this.updatePoolPointsData)
        if(res?.data?.updatePoolPointDetails?.statusCode === 200){
          this.getupdatePoolPoints.emit(this.updatePoolPointsData);
          this.discardSuccess = false;
          this.newPoolPointForm.patchValue({
            newPoolPoints: '',
            pendingCalcPoolPoints:''
          });
          console.log(this.newPoolPointForm)
          console.log(this.newPoolPointVal)
          console.log(this.poolPointsNewReason)
          this.poolPointsNewReason = '';
          this.selectedNewPoolPointsDateVal = null;
          this.pendingCalcDate = null;
          
          this.toasterService.openToast('Success', res?.data?.updatePoolPointDetails?.message);
        }else{
          this.toasterService.openToast('Error', res?.data?.updatePoolPointDetails?.message);
          this.errorPoolPointLoaderEvent.emit();
          this.closeSidePanel();
        }
        
      },
      error:(error:any)=>{
        this.toasterService.openToast('Error', error);
        this.errorPoolPointLoaderEvent.emit();
        this.closeSidePanel();
      }
    })
  }
  upComingfieldValue(e:any){
    this.newUpcomingReason = e
    // this.newUpcomingReason=   e + this.upComingReason;
    this.upComingReason = ''
    console.log(this.newUpcomingReason)
  }
  discardPoolPoint(){
    this.openDiscardPoolPoint = true;
    this.openEditPoolPoints = false;
    // this.openEditPoolPoints = false;
  }
  discardPoolPointChanges(){
    this.getPoolPointLoaderEvent.emit();
    let payload = {
      "vslNumber": this.shipDetailsbasicinfo?.vslNumber,
      "isDiscarded": true
    }
    this.vesselService.discardPoolPoints(payload).subscribe({
      next:(res:any)=>{
        console.log(res)
        if(res?.data?.discardPoolPointDetails?.statusCode === 200){
          this.discardPoolPointData = res?.data?.discardPoolPointDetails?.data;
          if(this.discardPoolPointData?.status !== 'upcomingChange'){
            this.showDiscardBanner = false;
          }
          this.discardSuccess = true;
          this.newPoolPointForm.patchValue({
            newPoolPoints: '',
            pendingCalcPoolPoints:''
          });
          this.getupdatePoolPoints.emit(this.discardPoolPointData);
          this.toasterService.openToast('Success', res?.data?.discardPoolPointDetails?.message);
          this.poolPointsNewReason = '';
          this.pendingCalcReason = '';
          console.log(this.poolPointsNewReason)
        }else{
          this.toasterService.openToast('Error',res?.data?.discardPoolPointDetails?.message);
          this.errorPoolPointLoaderEvent.emit();
          this.closeSidePanel();
        }
      },
      error:(error:any)=>{
        this.toasterService.openToast('Error',error);
        this.errorPoolPointLoaderEvent.emit();
        this.closeSidePanel();
      }
    })
  }

  selectedPendingPoolPointsDate(e:any){
    console.log(e)
    this.pendingCalcDate = e;
  }
  pendingfieldValue(e:any){
    console.log(e)
    this.pendingCalcReason = e;
    if(this.pendingCalcReason.length > 300){
      this.pendingCalcReasonError = true;
    }else{
      this.pendingCalcReasonError = false;
    }
  }
  revertPoolPoints(){
    this.openRestorePoolPoint = true; 
    this.openEditPoolPoints = false;
  }
  revertPoolPointsChanges(){
    this.getPoolPointLoaderEvent.emit();
    let payload = {
      "vslNumber": this.shipDetailsbasicinfo?.vslNumber,
      "isRestoreToPreviousAction": true
    }
    this.vesselService.revertPoolPointDetails(payload).subscribe({
      next:(res:any)=>{
        console.log(res)
        if(res?.data?.revertPoolPointDetails?.statusCode === 200){
          this.revertPoolPointData = res?.data?.revertPoolPointDetails?.data;
          // this.notifyService.showSuccess('Success', res?.data?.revertPoolPointDetails?.message);
          this.getupdatePoolPoints.emit(this.revertPoolPointData);
          this.newPoolPointForm.patchValue({
            newPoolPoints: '',
            pendingCalcPoolPoints:''
          });
          this.pendingCalcReason = '';
          this.toasterService.openToast('Success', res?.data?.revertPoolPointDetails?.message);
          this.editPoolPointsVal = '';
        }else{
          this.toasterService.openToast('Error',res?.data?.revertPoolPointDetails?.message);
          this.errorPoolPointLoaderEvent.emit();
          this.closeSidePanel();
        }    
      },
      error:(error:any)=>{
        this.toasterService.openToast('Error',error);
        this.errorPoolPointLoaderEvent.emit();
        this.closeSidePanel();
      }
    })
  }
  cancelPoolPoint(){
    console.log("yes")
    this.newPoolPointForm.patchValue({
      newPoolPoints: '',
      pendingCalcPoolPoints:''
    });
    this.editPoolPointsVal = '';
    this.callGetPoolPointDetails();
  }
  closeSidePanel(){
    this.editPoolPointsVal = '';
    this.poolPointsReason = '';
    this.selectedPoolPointsDateVal = null;
    this.selectedNewPoolPointsDateVal = null;
    this.poolPointsNewReason = '';
    this.showNewPoolPointsErrorMsg = false;
    this.showPoolPointsPendingErrorMsg = false;
    // this.showScrubberPointsPendingErrorMsg = false;
    this.newPoolPointForm.patchValue({
      newPoolPoints: '',
      pendingCalcPoolPoints:''
    });
  }
  handleFocusOutNewPoolPoints(e:any){
    this.showNewPoolPointsErrorMsg = true;
    
  }
  handleFocusOutPoolPointsPending(e:any){
    this.showPoolPointsPendingErrorMsg = true;
  }

  isPoolPointsInputError(controlName: 'newPoolPoints' | 'pendingCalcPoolPoints'): boolean {
    return !!this.getPoolPointsInputErrorMessage(controlName);
  }

  getPoolPointsInputErrorMessage(controlName: 'newPoolPoints' | 'pendingCalcPoolPoints'): string {
    const control = this.newPoolPointForm?.get(controlName);
    if (!control?.invalid) {
      return '';
    }

    const showOnSubmit = controlName === 'newPoolPoints'
      ? this.showNewPoolPointsErrorMsg
      : this.showPoolPointsPendingErrorMsg;

    if (control.hasError('pattern') && control.dirty) {
      return this.poolPointsPatternMessage;
    }

    if (control.hasError('required') && (control.dirty || (showOnSubmit && control.touched))) {
      return this.poolPointsRequiredMessages[controlName];
    }

    return '';
  }
}